

















































import Vue from 'vue';
import JerseyButtonYellowLong from '@/components/elements/JerseyButtonYellowLong.vue';
import JerseyButtonYellowMedium from '@/components/elements/JerseyButtonYellowMedium.vue';
import JerseyButtonRedLong from '@/components/elements/JerseyButtonRedLong.vue';
import twitter from '@/libs/share-twitter';
import { checkLoginStatus, embed, embedPromise, share } from '@/libs/facebook';
import ShortenRequest from '../../common/api/IShortenRequest';
import ShortenResponse from '../../common/api/IShortenResponse';
import { uuidFromURL } from '../../common/helper/strings';
import axios from 'axios';

export default Vue.extend({
  name: 'Success',
  data() {
    return {
      windowSize: 0,
      babyText: '',
    };
  },
  components: {
    JerseyButtonYellowLong,
    JerseyButtonRedLong,
    JerseyButtonYellowMedium,
  },
  async mounted() {
    // Wait for facebook to be embedded in the page
    const FB = await embedPromise(process.env.VUE_APP_FB_ID);
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  created() {
    this.babyText = this.hasCreatedBaby
      ? 'Name Another Baby!'
      : 'Name Your Baby!';
  },
  methods: {
    reset() {
      window.gtag('event', 'create_another', {
        event_category: 'engagement',
        event_label: 'clicked',
      });

      window.location.href = window.location.origin;
    },
    async shareTwitter() {
      const twitterUrl: string = window.location.pathname;
      twitter(
        twitterUrl,
        `Welcome to the world, ${this.imgAlt}! We’re watching #JSFamilyVacation every Jerzday night at 8/7c on MTV!`,
        'MTV Baby name generator',
        [],
      );
      window.gtag('event', 'share', {
        event_category: 'engagement',
        event_label: 'twitter',
      });
    },
    shareFacebook() {
      const facebookUrl: string = window.location.pathname;
      share(
        facebookUrl,
        `Welcome to the world, ${this.imgAlt}! We’re watching #JSFamilyVacation every Jerzday night at 8/7c on MTV!`,
      );
      window.gtag('event', 'share', {
        event_category: 'engagement',
        event_label: 'facebook',
      });
    },
    onResize() {
      this.windowSize = window.innerWidth;
    },
  },
  computed: {
    jerzday() {
      return (this as any).$store.state.jerzday;
    },
    imgUrl() {
      return (window as any).babyNameURL;
    },
    imgAlt() {
      return (window as any).babyName;
    },
    isMobile() {
      return (this as any).windowSize < 1030;
    },
    hasCreatedBaby() {
      return window.location.search.indexOf('createdBaby') !== -1;
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
});
